define('gameday-index-gdaudio/subcomponents/AudioFeedModel',['require','exports','module'],function(require, exports, module) {
	var data;

	function AudioFeedModel($data, $game) {
	var data = $data,
		game = $game.linescore;

		return {
			type: "audio",
			contentID: data.id,
			callLetters: data.display,
			mediaState: data.combined_media_state,
			displayCode: ( data.type.indexOf("away") !== -1 ) ? game.away_name_abbrev.toUpperCase() : game.home_name_abbrev.toUpperCase(),
			teamCode   : ( data.type.indexOf("away") !== -1 ) ? game.away_code : game.home_code,
			selected: false
		}
	}

	return AudioFeedModel;
});
